const Indexing = () => import(/* webpackChunkName: "manager" */ './Index');

export default {
  routes: [
    {
      path: '/papr/indexing',
      name: 'papr_indexing',
      component: Indexing
    }
  ]
}
